import type { LucideIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

/**
 * Educational empty state - says what the feature is, why it matters, and
 * offers a real first step (often seeding a starter template) instead of a
 * bare "nothing here" line.
 */
export const EmptyState = ({
  icon: Icon,
  title,
  body,
  primaryLabel,
  onPrimary,
  secondaryLabel,
  onSecondary,
  footnote,
}: {
  icon: LucideIcon;
  title: string;
  body: string;
  primaryLabel: string;
  onPrimary: () => void;
  secondaryLabel?: string;
  onSecondary?: () => void;
  footnote?: string;
}) => (
  <Card className="max-w-xl">
    <CardContent className="p-6 flex flex-col items-start gap-3">
      <span className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-muted">
        <Icon className="w-5 h-5 text-muted-foreground" />
      </span>
      <div>
        <h3 className="font-semibold">{title}</h3>
        <p className="text-sm text-muted-foreground leading-6 mt-1">{body}</p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <Button size="sm" onClick={onPrimary}>
          {primaryLabel}
        </Button>
        {secondaryLabel && onSecondary && (
          <Button size="sm" variant="outline" onClick={onSecondary}>
            {secondaryLabel}
          </Button>
        )}
      </div>
      {footnote && (
        <p className="text-[11px] text-muted-foreground">{footnote}</p>
      )}
    </CardContent>
  </Card>
);
